import React from 'react';

import './ServiceSection.css';

const ServiceSection = ({
  id,
  eyebrow,
  headline,
  paragraphs,
  rows,
  tone = 'light',
  reverse = false,
  children,
}) => (
  <section
    id={id}
    className={`service service--${tone}${reverse ? ' service--reverse' : ''}`}
    aria-labelledby={`${id}-title`}
  >
    <div className="container service__grid">
      <div className="service__text">
        <h2 id={`${id}-title`} className="display service__title">
          <span className="eyebrow">{eyebrow}</span>
          {headline}
        </h2>
        {paragraphs.map((text) => (
          <p key={text}>{text}</p>
        ))}
        {children}
      </div>

      <div className="service__media">
        {rows.map((row) => (
          <div className="service__row" key={row.map((item) => item.image.src).join()}>
            {row.map(({ image, alt }) => (
              <figure key={image.src} style={{ flex: `${image.width / image.height} 1 0` }}>
                <img
                  src={image.src}
                  alt={alt}
                  width={image.width}
                  height={image.height}
                  loading="lazy"
                  decoding="async"
                />
              </figure>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServiceSection;
